import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import Cookies from 'js-cookie'
import useGlobal from 'hooks/useGlobal'

function WebclapRoute({ component: Component, type, ...rest }) {
	const [config] = useGlobal(state => state.config)

	if (!config) return null

	return (
		<Route
			{...rest}
			render={props => {
				// if ((sessionStorage && sessionStorage.getItem('installed')) || !config.error) {
				if (!config.error) {
					const isAuthenticated = !!Cookies.get('jtp')
					// 설치된경우
					if (type === 'install') return <Redirect to="/" /> // 설치경로로 들어오면 메인으로 리다이렉트
					if (type === 'login' && isAuthenticated) return <Redirect to="/" /> // 이미 인증되었으면 로그인화면 접근 불가능. 메인으로 리다이렉트
					if (type === 'private' && !isAuthenticated) return <Redirect to="/login" /> // 미인증이 private경로로 들어오면 로그인으로 리다이렉트
					return <Component {...props} />
				} else {
					// 설치안된경우
					return type === 'install' ? <Component {...props} /> : <Redirect to="/install" />
				}
			}}
		/>
	)
}

export default WebclapRoute
